<template>
  <div class="confirm-warp">
    <popup-warp v-model="isMyPosOnlinePay">
      <div class="myPos-input">
        <div id="myPOSEmbeddedCheckout" ref="myPOSEmbeddedCheckout"></div>
      </div>
    </popup-warp>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { PopupWarp } from "../../components/popup"
import multicurrencyMixin from "../../mixins/multicurrency"

import { ORDER_SAVEDCARDTORENT } from "../../apis/cabinet.js"
export default {
  name: "myPosPayment",
  mixins: [multicurrencyMixin],
  components: {
    PopupWarp
  },
  computed: {
    ...mapState(["system", "browser"])
  },
  data() {
    return {
      isMyPosOnlinePay: false
    }
  },
  methods: {
    /**
     * myPosOnlinePay 完成回调函数
     */
    myPosSaveCallBack(res, paymentInfo) {
      this.isMyPosOnlinePay = false
      if (res.orderId && res.orderStatus) {
        if (res.type === "SaveCard") {
          this.saveToRent(res.qrcode, paymentInfo.payMode)
        } else {
          this.checkOrder(res.orderId, paymentInfo.payMode)
        }
      } else {
        this.$toast(res)
      }
    },
    // myPos 支付方法
    myPosPay(paymentInfo, paymentWay) {
      let payInfo = {}
      try {
        payInfo = JSON.parse(paymentInfo)
      } catch (e) {
        console.error("myPosPay-error:", e)
      }

      if (Object.keys(payInfo).length) {
        if (payInfo.paymentId) {
          if (payInfo.token) {
            this.$store.commit("token", payInfo.token)
          }
          this.myPosSaveCard(
            (res) => this.myPosSaveCallBack(res, paymentInfo),
            payInfo.paymentId
          )
        } else {
          this.loadMyPosOnlinePay(payInfo, (res) =>
            this.myPosSaveCallBack(res, paymentInfo)
          )
        }
      }
    },

    saveToRent(qrcode, payMode) {
      this.$loading(true)
      const query = { qrcode: qrcode }
      this.$get(
        `${ORDER_SAVEDCARDTORENT}`,
        query,
        (resp) => {
          this.$loading(false)
          if (resp.data && resp.data.out_trade_no) {
            this.checkOrder(resp.data.out_trade_no, payMode)
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        },
        { headers: { "Content-Type": "application/json;charset=UTF-8" } }
      )
    },

    checkOrder(tradeNo, payType) {
      let _path = `/result?tradeNo=${tradeNo}&payMode=myPos`
      if (payType === "FK") {
        _path = `/result?tradeNo=${tradeNo}&payMode=myPos&payType=FK`
      }
      this.$router.replace(_path)
    }
  },
  created() {
    this.Query = this.$route.query
    const { paymentInfo, paymentWay } = this.$route.query
    if (paymentInfo && paymentWay) {
      this.loadMyPOSEmbeddedScript("", () => {
        this.myPosPay(paymentInfo, paymentWay)
      })
    }
  }
}
</script>

<style lang="less">
</style>
